import { Component, EventEmitter, Input, Output } from "@angular/core";

@Component({
  selector: "app-tabs",
  templateUrl: "./tabs.component.html",
  styleUrls: ["./tabs.component.scss"],
})
export class TabsComponent {
  @Input() tabs: string[] = [];
  @Input() activeTab: string = "";

  @Output() onTabActivated = new EventEmitter<string>();

  emitSelectedTab(tab: string) {
    this.activeTab = tab;
    this.onTabActivated.emit(tab);
  }

  isTabActive(tab: string) {
    return tab === this.activeTab;
  }
}
